import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const entityCapService = createApi({
    reducerPath: 'entityCapService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['EntityCap'],
    endpoints: (builder) => ({

        getAllEntityCap: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityCapController.getAllEntityCap}/${body.page}/${body.size}?orderBy=${body.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),

        saveEntityCap: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityCapController.saveEntityCap}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),

        updateEntityCap: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityCapController.updateEntityCap}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),

        deleteEntityCap: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityCapController.deleteEntityCap}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),

        getAllEntityCapBySearch: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityCapController.getAllEntityCapBySearch}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),

        findAllEntityCap: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityCapController.findAllEntityCap}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),

        getEntityCapByEntity: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityCapController.getByEntity}/${body.entityId}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),

        bulkSaveEntityCap: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityCapController.bulkSaveEntityCap}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),

        getEntityCapById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.entityCapController.getEntityCapById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),

    }),
});

export const {
    useGetAllEntityCapMutation,
    useSaveEntityCapMutation,
    useUpdateEntityCapMutation,
    useDeleteEntityCapMutation,
    useGetAllEntityCapBySearchMutation,
    useFindAllEntityCapMutation,
    useGetEntityCapByEntityMutation,
    useBulkSaveEntityCapMutation,
    useGetEntityCapByIdMutation,
} = entityCapService;
